import { create } from 'zustand'

const useSearchStore = create(
        set => ({
            searchString: '',
            setSearchString: searchString => set(state => ({
                ...state,
                searchString
            })),
            searchInputString: '',
            setSearchInputString: searchInputString => set(state => ({
                ...state,
                searchInputString
            })),
        }),
)

export default useSearchStore